import { createFileRoute } from "@tanstack/react-router";
import DockerfileLinterPage from "@/pages/DockerfileLinterPage";

export const Route = createFileRoute("/tools/dockerfile-linter")({
  component: DockerfileLinterPage,
});
